import { render, staticRenderFns } from "./buildDetail.vue?vue&type=template&id=0a085a70&scoped=true&"
import script from "./buildDetail.vue?vue&type=script&lang=js&"
export * from "./buildDetail.vue?vue&type=script&lang=js&"
import style0 from "./buildDetail.vue?vue&type=style&index=0&id=0a085a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a085a70",
  null
  
)

export default component.exports